<ion-header>
  <ion-toolbar color="white">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'UPDATE.title' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="ion-padding" color="white">
    <div class="content-div">
      <ion-img class="img center" src="./assets/wedding/img/news/whatsapp/launching/img.webp"></ion-img>
      <div class="full-width ion-text-center">
        <ion-text class="font-20 font-med" [innerHTML]="'UPDATE.whatsapp.title' | translate"></ion-text>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" [fullscreen]="true" color="light">
  <div class="content-div ion-text-left ion-margin">
    <ion-text class="font-14" [innerHTML]="'UPDATE.whatsapp.msg' | translate"></ion-text>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion-padding">
    <div class="content-div">
      <ion-button class="btn" expand="block" (click)="start()">
        {{ 'BTN.get_start' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
